(function () {
  'use strict';

  function details(rawValue) {
    const original = String(rawValue == null ? '' : rawValue).trim();
    if (!original) return { cm: 0, source: '', valid: false };

    const value = original
      .toLocaleLowerCase('tr-TR')
      .replace(/,/g, '.')
      .replace(/\s+/g, ' ')
      .trim();

    const metresAndCm = value.match(/^(\d+(?:\.\d+)?)\s*(?:metre|mt|m)(?:\s*(\d+(?:\.\d+)?)\s*(?:cm|santimetre|santim))?$/i);
    if (metresAndCm) {
      const cm = Number(metresAndCm[1]) * 100 + Number(metresAndCm[2] || 0);
      return { cm: Math.round(cm * 100) / 100, source: 'm', valid: cm > 0 };
    }

    const explicitCm = value.match(/^(\d+(?:\.\d+)?)\s*(?:cm|santimetre|santim)$/i);
    if (explicitCm) {
      const cm = Number(explicitCm[1]);
      return { cm: Math.round(cm * 100) / 100, source: 'cm', valid: cm > 0 };
    }

    const plain = value.match(/^\d+(?:\.\d+)?$/);
    if (!plain) return { cm: 0, source: '', valid: false };

    const number = Number(value);
    if (!Number.isFinite(number) || number <= 0) return { cm: 0, source: '', valid: false };

    // A bare value up to and including 20 is treated as metres. A 20 cm wall
    // side is not orderable anywhere in this flow, while 20 m mural widths are.
    // Values above 20 continue to mean centimetres for production.
    const isMetres = number <= 20;
    const cm = isMetres ? number * 100 : number;
    return {
      cm: Math.round(cm * 100) / 100,
      source: isMetres ? 'm' : 'cm',
      valid: true
    };
  }

  function parseCm(rawValue) {
    return details(rawValue).cm;
  }

  function formatCm(cm) {
    return Number(cm).toLocaleString('tr-TR', {
      minimumFractionDigits: Number.isInteger(cm) ? 0 : 1,
      maximumFractionDigits: 2
    });
  }

  function formatMetres(cm) {
    return (Number(cm) / 100).toLocaleString('tr-TR', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    });
  }

  function feedbackHost(input) {
    return input.closest(
      '.wp-cta-card__dim-field, .wp-roll-calc__field, .input-wrapper, ' +
      '.customizer__field, .cm-field, .mural-cta-card__size-field'
    ) || input.parentElement;
  }

  function updateFeedback(input) {
    const result = details(input.value);
    input.dataset.cmValue = result.valid ? String(result.cm) : '';
    const host = feedbackHost(input);
    if (!host) return;
    let feedback = host.querySelector(':scope > .dk-measure-feedback');
    if (!feedback) {
      feedback = document.createElement('small');
      feedback.className = 'dk-measure-feedback';
      feedback.setAttribute('aria-live', 'polite');
      host.appendChild(feedback);
    }

    if (!String(input.value || '').trim()) {
      feedback.textContent = '';
      feedback.hidden = true;
      feedback.classList.remove('has-value', 'has-error');
      return;
    }

    if (!result.valid) {
      feedback.hidden = false;
      feedback.textContent = 'Örn. 2,06 m veya 206 cm';
      feedback.classList.remove('has-value');
      feedback.classList.add('has-error');
      return;
    }

    if (result.source !== 'm') {
      feedback.textContent = '';
      feedback.hidden = true;
      feedback.classList.remove('has-value', 'has-error');
      return;
    }

    feedback.hidden = false;
    feedback.textContent = `= ${formatCm(result.cm)} cm`;
    feedback.classList.add('has-value');
    feedback.classList.remove('has-error');
  }

  function enhance(input) {
    if (!input || input.dataset.flexCmReady === 'true') return;
    input.dataset.flexCmReady = 'true';
    input.type = 'text';
    input.inputMode = 'decimal';
    input.autocomplete = 'off';
    input.removeAttribute('min');
    input.removeAttribute('max');
    input.removeAttribute('step');
    updateFeedback(input);
  }

  function init(root) {
    (root || document).querySelectorAll('[data-flex-cm]').forEach(enhance);
  }

  window.DuvarkaplaMeasurements = {
    parseCm: parseCm,
    details: details,
    init: init,
    updateFeedback: updateFeedback
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Delegation also handles inputs inserted or cloned after page load without
  // scanning unrelated app, search, cart, or image mutations across the page.
  function onMeasurementEvent(event) {
    const input = event.target;
    if (!input.matches || !input.matches('[data-flex-cm]')) return;
    if (input.dataset.flexCmReady !== 'true') enhance(input);
    else updateFeedback(input);
  }

  document.addEventListener('focusin', function (event) {
    const input = event.target;
    if (input.matches && input.matches('[data-flex-cm]')) enhance(input);
  });
  document.addEventListener('input', onMeasurementEvent, true);
  document.addEventListener('blur', onMeasurementEvent, true);
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
